import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import GLightbox from 'glightbox';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  lightbox:any;
  tokenValid: boolean;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    // setTimeout(() => {
    //   this.router.navigate(['/about-us']);
    // }, 300);

    // if (!localStorage.getItem('up')) {
    //   localStorage.setItem('up', 'no reload');
    //   location.reload();
    // } else {
    //   localStorage.removeItem('up');
    // }

    this.lightbox = GLightbox({
      'href': 'https://www.youtube.com/watch?v=bqb0Ks1KMQ0',
      'type': 'video',
      'source': 'youtube', //vimeo, youtube or local
      'width': 900,
      'autoplayVideos': true,
    });
  }

}
